<template>
  <div class="placeholder">
    <div class="placeholder__range">
      <div class="placeholder__track"></div>
      <div class="placeholder__track placeholder__track--active"></div>
      <div class="placeholder__handle placeholder__handle--left"></div>
      <div class="placeholder__handle placeholder__handle--right"></div>
    </div>
    <div class="placeholder__lines">
      <LinePreload class="placeholder__input" :h="30" :w="82" :isL="true" />
      <LinePreload class="placeholder__input" :h="30" :w="82" :isL="true" />
    </div>
  </div>
</template>

<script>
export default {
  name: "RangePlaceholder"
};
</script>

<style scoped lang="scss">
.placeholder {
  width: calc(173px * 2 + 20px);
  margin-right: 20px;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-self: flex-end;
  position: relative;
  &__range {
    display: block;
    width: 173px;
  }
  &__track {
    width: 172px;
    height: 3px;
    display: block;
    position: absolute;
    background-color: #f5f5f5;
    top: 50%;
    transform: translateY(-50%);
    &--active {
      background-color: #a42a7b;
      width: 90px;
      left: 0;
    }
  }
  &__handle {
    width: 12px;
    height: 12px;
    position: absolute;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    background-color: #a42a7b;
    border-radius: 50%;
    &--right {
      left: 90px;
    }
  }
  &__lines {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 173px;
  }
  &__input {
    border-radius: 15px;
    overflow: hidden;
  }
}
</style>
